import { render, staticRenderFns } from "./ButtonsComponent.vue?vue&type=template&id=6de7bd07"
import script from "./ButtonsComponent.vue?vue&type=script&lang=js"
export * from "./ButtonsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports